import React from 'react';
import {Badge} from 'react-bootstrap';

const DeliveryDetails = ({orderDetails, isLoading, onClose, bookingId}) => {
    return (
        <tr>
            <td colSpan='7' className='p-1'>
                <div className='bg-light border-top'>
                    <div className='p-4'>
                        <div className='d-flex justify-content-between align-items-center mb-3'>
                            <h5 className='mb-0 text-primary'>Order Details</h5>
                            <button
                                className='btn btn-sm btn-outline-secondary'
                                onClick={() => onClose(bookingId)}
                            >
                                <i className='las la-times'></i> Close
                            </button>
                        </div>

                        {isLoading ? (
                            <LoadingState />
                        ) : orderDetails ? (
                            <OrderDetailsContent orderDetails={orderDetails} />
                        ) : (
                            <NoDataState />
                        )}
                    </div>
                </div>
            </td>
        </tr>
    );
};

const LoadingState = () => (
    <div className='text-center py-4'>
        <div className='spinner-border text-primary' role='status'>
            <span className='sr-only'>Loading...</span>
        </div>
        <p className='mt-2'>Loading order details...</p>
    </div>
);

const NoDataState = () => (
    <div className='text-center py-4'>
        <i
            className='las la-exclamation-circle text-warning'
            style={{fontSize: '48px'}}
        ></i>
        <p className='mt-2'>No details available for this order.</p>
    </div>
);

const OrderDetailsContent = ({orderDetails}) => {
    const hasDeliveryAddress =
        orderDetails.hasOwnProperty('delivery_address') &&
        orderDetails.delivery_address &&
        Object.keys(orderDetails.delivery_address).length > 0;

    return (
        <>
            <div className='row'>
                {hasDeliveryAddress && (
                    <DeliveryAddress address={orderDetails.delivery_address} />
                )}

                <OrderSummary
                    summary={orderDetails}
                    colClass={hasDeliveryAddress ? 'col-md-6' : 'col-lg-10'}
                />
            </div>
            <FoodItems foodList={orderDetails.foodlist} />
        </>
    );
};



const DeliveryAddress = ({address}) => {
    if (!address) return null;

    return (
        <div className='col-md-6 mb-3'>
            <h6 className='text-muted mb-2'>
                <i className='las la-map-marker mr-2'></i>
                Delivery Address
            </h6>
            <div className='bg-white p-3 rounded border'>
                <p className='mb-1'>
                    <strong>{address.addr_line_1}</strong>
                </p>
                {address.addr_line_2 && (
                    <p className='mb-1'>{address.addr_line_2}</p>
                )}
                {address.addr_line_3 && (
                    <p className='mb-1'>{address.addr_line_3}</p>
                )}
                {address.phone && (
                    <p className='mb-1'>
                        <i className='las la-phone mr-1'></i>
                        {address.phone}
                    </p>
                )}
            </div>
        </div>
    );
};

const OrderSummary = ({summary, colClass = 'col-md-6'}) => (
    <div className={`${colClass} mb-3`}>
        <h6 className='text-muted mb-2'>
            <i className='las la-calculator mr-2'></i>
            Order Summary
        </h6>
        <div className='bg-white p-3 rounded border'>
            <div className='d-flex justify-content-between mb-2'>
                <span>Food Charge:</span>
                <strong>SAR {summary.food_charge}</strong>
            </div>
            <div className='d-flex justify-content-between mb-2'>
                <span>Booking Charge:</span>
                <strong>SAR {summary.booking_charge}</strong>
            </div>
            <div className='d-flex justify-content-between mb-2'>
                <span>VAT:</span>
                <strong>SAR {summary.vat}</strong>
            </div>
            <hr className='my-2' />
            <div className='d-flex justify-content-between mb-2'>
                <span className='h6'>Total:</span>
                <strong className='h6 text-success'>SAR {summary.total}</strong>
            </div>
            <div className='d-flex justify-content-between'>
                <span>Balance to Pay:</span>
                <strong className='text-warning'>
                    SAR {summary.balance_to_pay}
                </strong>
            </div>
        </div>
    </div>
);


const FoodItems = ({foodList}) => (
    <div className='mb-3'>
        <h6 className='text-muted mb-2'>
            <i className='las la-utensils mr-2'></i>
            Food Items
        </h6>
        <div className='bg-white rounded border'>
            {foodList?.map((item, index) => (
                <FoodItem
                    key={index}
                    item={item}
                    isLast={index === foodList.length - 1}
                />
            ))}
        </div>
    </div>
);

const FoodItem = ({item, isLast}) => (
    <div
        className='d-flex align-items-center p-3'
        style={{
            borderBottom: !isLast ? '1px solid #dee2e6' : 'none',
        }}
    >
        <div className='mr-3'>
            <img
                src={process.env.REACT_APP_API_RESOURCE_URL + item.img}
                alt={item.item_name}
                className='rounded'
                style={{
                    width: '50px',
                    height: '50px',
                    objectFit: 'cover',
                }}
            />
        </div>
        <div className='flex-grow-1'>
            <h6 className='mb-1'>{item.item_name}</h6>
            <p className='mb-1 text-muted'>Quantity: {item.qty}</p>
            {item.customisation && (
                <p className='mb-1 text-info small'>
                    Customisation: {item.customisation_val}
                </p>
            )}
        </div>
        <div className='text-right'>
            <strong className='text-success'>SAR {item.total}</strong>
            <br />
            <Badge variant={item.is_paid ? 'success' : 'warning'}>
                {item.is_paid ? 'Paid' : 'Unpaid'}
            </Badge>
        </div>
    </div>
);

export default DeliveryDetails;
